import React from "react";

export const Skills = () => {
  return <>Skills Mine</>;
};
